import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import Hero from "@/sections/Hero";
import { ScrollProgress } from "@/components/ScrollProgress";
import { Marquee } from "@/components/Marquee";
import Problem from "@/sections/Problem";
import Solution from "@/sections/Solution";
import DeviceSection from "@/sections/DeviceSection";
import Protects from "@/sections/Protects";
import Regulatory from "@/sections/Regulatory";
import Contact from "@/sections/Contact";
import Footer from "@/sections/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#09090F] text-[#E4E5EA]/90">
      <ScrollProgress />
      <Hero />
      <Marquee />
      <Problem />
      <Solution />
      <DeviceSection />
      <Protects />
      <Regulatory />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
